const config = {
    apiString: 'https://pen.gruppera.se/api/' 
};
 
export default config;